define.alias("ember-math-helpers/helpers/div", "media/helpers/div");